import React from 'react'

import {Card, H5, H3, P} from '../../../../components/UI/index.js'
import {formSpacing, FormStack, Input, Select, Toggle, Editor} from '../../../../components/UI/forms/index.js'
import {Reseller} from '../../../../../server/functions/resellers/resellers.types.js'
import t from '../../../../helpers/Languages.js'
import SnelStartVerification from './SnelStartVerification.js'

interface AdministrationSettingsProps {
    reseller: Reseller
    onChange: (reseller: Reseller, key?: string) => void
}

export default class AdministrationSettings extends React.Component<AdministrationSettingsProps> {
    onChangeChecked(option, event) {
        const {reseller, onChange} = this.props
        reseller.settings.administration[option] = event.target.checked
        onChange(reseller, `administration[${option}]`)
    }

    onChangeValue(key, event) {
        const {reseller, onChange} = this.props
        reseller.settings.administration[key] = event.target.value
        onChange(reseller)
    }

    onSaveValue(key, event) {
        const {reseller, onChange} = this.props

        if (event && event.target) {
            reseller.settings.administration[key] = event.target.value
        }

        onChange(reseller, `administration[${key}]`)
    }

    render() {
        const {reseller} = this.props

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                <H3 style={{marginBottom: 36}}>{t('administration')}</H3>

                <H5 style={{marginBottom: 24}}>{t('accountingConnection')}</H5>
                <P style={{marginBottom: 24}}>{t('accountingConnectionDescription')}</P>

                <FormStack>
                    <Select
                        label={t('accountingSystem')}
                        allowEmpty
                        placeholder={t('noAccountingSystem')}
                        value={reseller.settings.administration.api}
                        onChange={this.onSaveValue.bind(this, 'api')}
                    >
                        <option value='AFAS'>AFAS</option>
                        <option value='JORTT'>JORTT</option>
                        <option value='JORTT V2'>JORTT V2</option>
                        <option value='SnelStart'>SnelStart</option>
                        <option value='WeFact'>WeFact</option>
                        <option value='Twinfield'>Twinfield</option>
                    </Select>

                    {reseller.settings.administration.api &&
                        <Select
                            label={t('syncCustomers')}
                            value={reseller.settings.administration.syncCustomers}
                            onChange={this.onSaveValue.bind(this, 'syncCustomers')}
                        >
                            <option value=''>{t('no')}</option>
                            <option value='yes'>{t('yes')}</option>
                            <option value='fromVeloyd'>{t('syncCustomersFromVeloyd', reseller.settings.administration.api)}</option>
                            <option value='toVeloyd'>{t('syncCustomersToVeloyd', reseller.settings.administration.api)}</option>
                        </Select>
                    }

                    {reseller.settings.administration.api && ['yes', 'toVeloyd'].includes(reseller.settings.administration.syncCustomers) &&
                        <Toggle
                            label={t('noNewCustomersInVeloyd')}
                            info={t('noNewCustomersInVeloydInfo')}
                            checked={reseller.settings.administration.noNewCustomers}
                            onChange={this.onChangeChecked.bind(this, 'noNewCustomers')}
                        />
                    }

                    {reseller.settings.administration.api && ['yes', 'toVeloyd'].includes(reseller.settings.administration.syncCustomers) &&
                        <Toggle
                            label={t('customersNotEditableInVeloyd')}
                            info={t('customersNotEditableInVeloydInfo')}
                            checked={reseller.settings.administration.customersNotEditable}
                            onChange={this.onChangeChecked.bind(this, 'customersNotEditable')}
                        />
                    }

                    {reseller.settings.administration.api === 'AFAS' &&
                        <>
                            <Input
                                label={t('environmentNumber')}
                                value={reseller.settings.administration.apiEnvironment}
                                onChange={this.onChangeValue.bind(this, 'apiEnvironment')}
                                onBlur={this.onSaveValue.bind(this, 'apiEnvironment')}

                            />

                            <Input
                                label={t('apiKey')}
                                value={reseller.settings.administration.apiKey}
                                onChange={this.onChangeValue.bind(this, 'apiKey')}
                                onBlur={this.onSaveValue.bind(this, 'apiKey')}
                            />

                            <Input
                                label={t('warehouse')}
                                value={reseller.settings.administration.afasWarehouse}
                                onChange={this.onChangeValue.bind(this, 'afasWarehouse')}
                                onBlur={this.onSaveValue.bind(this, 'afasWarehouse')}
                            />

                            <Input
                                label={t('administration')}
                                value={reseller.settings.administration.afasAdministration}
                                onChange={this.onChangeValue.bind(this, 'afasAdministration')}
                                onBlur={this.onSaveValue.bind(this, 'afasAdministration')}
                            />

                            <Input
                                label={t('typeItem')}
                                value={reseller.settings.administration.afasTypeItem}
                                onChange={this.onChangeValue.bind(this, 'afasTypeItem')}
                                onBlur={this.onSaveValue.bind(this, 'afasTypeItem')}
                            />

                            <Input
                                label={t('unit')}
                                value={reseller.settings.administration.afasUnit}
                                onChange={this.onChangeValue.bind(this, 'afasUnit')}
                                onBlur={this.onSaveValue.bind(this, 'afasUnit')}
                            />

                            <Input
                                label={t('afasCustomerGetConnector')}
                                value={reseller.settings.administration.afasCustomerGetConnector}
                                onChange={this.onChangeValue.bind(this, 'afasCustomerGetConnector')}
                                onBlur={this.onSaveValue.bind(this, 'afasCustomerGetConnector')}
                            />

                            <Input
                                label={t('afasFieldDebtorId')}
                                placeholder='DebtorId'
                                value={reseller.settings.administration.afasGUIDDebtorId}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDDebtorId')}
                            />

                            <Input
                                label={t('afasFieldDebtorName')}
                                placeholder='DebtorName'
                                value={reseller.settings.administration.afasGUIDDebtorName}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDDebtorName')}
                            />

                            <Input
                                label={t('afasFieldEmail')}
                                value={reseller.settings.administration.afasGUIDEmail}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDEmail')}
                            />

                            <Input
                                label={t('afasFieldPhone')}
                                value={reseller.settings.administration.afasGUIDPhone}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDPhone')}
                            />

                            <Input
                                label={t('afasFieldStreet')}
                                placeholder='AdressLine1'
                                value={reseller.settings.administration.afasGUIDStreet}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDStreet')}
                            />

                            <Input
                                label={t('afasFieldNr')}
                                value={reseller.settings.administration.afasGUIDNr}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDNr')}
                            />

                            <Input
                                label={t('afasFieldAddition')}
                                value={reseller.settings.administration.afasGUIDAddition}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDAddition')}
                            />

                            <Input
                                label={t('afasFieldStreet2')}
                                placeholder='AdressLine2'
                                value={reseller.settings.administration.afasGUIDStreet2}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDStreet2')}
                            />

                            <Input
                                label={t('afasFieldPostalCode')}
                                placeholder='AdressLine3'
                                value={reseller.settings.administration.afasGUIDPostalCode}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDPostalCode')}
                            />

                            <Input
                                label={t('afasFieldCity')}
                                placeholder='AdressLine4'
                                value={reseller.settings.administration.afasGUIDCity}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDCity')}
                            />

                            <Input
                                label={t('afasFieldCountryCode')}
                                value={reseller.settings.administration.afasGUIDCountryCode}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDCountryCode')}
                            />

                            <Input
                                label={t('afasGuidVeloydId')}
                                value={reseller.settings.administration.afasGUIDVeloydId}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDVeloydId')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDVeloydId')}
                            />

                            <Input
                                label={t('afasGuidCustomerReference')}
                                value={reseller.settings.administration.afasGUIDCustomerReference}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDCustomerReference')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDCustomerReference')}
                            />

                            <Input
                                label={t('afasGuidTrackTrace')}
                                value={reseller.settings.administration.afasGUIDTrackTrace}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDTrackTrace')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDTrackTrace')}
                            />

                            <Input
                                label={t('afasGuidCarrier')}
                                value={reseller.settings.administration.afasGUIDCarrier}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDCarrier')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDCarrier')}
                            />

                            <Input
                                label={t('afasGuidOptions')}
                                value={reseller.settings.administration.afasGUIDOptions}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDOptions')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDOptions')}
                            />

                            <Input
                                label={t('afasGuidCountry')}
                                value={reseller.settings.administration.afasGUIDCountry}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDCountry')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDCountry')}
                            />

                            <Input
                                label={t('afasGuidWeight')}
                                value={reseller.settings.administration.afasGUIDWeight}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDWeight')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDWeight')}
                            />

                            <Input
                                label={t('afasGuidInfo')}
                                value={reseller.settings.administration.afasGUIDInfo}
                                onChange={this.onChangeValue.bind(this, 'afasGUIDInfo')}
                                onBlur={this.onSaveValue.bind(this, 'afasGUIDInfo')}
                            />
                        </>
                    }

                    {reseller.settings.administration.api === 'JORTT' &&
                        <>
                            <Input
                                label={t('name')}
                                value={reseller.settings.administration.apiName}
                                onChange={this.onChangeValue.bind(this, 'apiName')}
                                onBlur={this.onSaveValue.bind(this, 'apiName')}
                            />

                            <Input
                                label={t('apiKey')}
                                value={reseller.settings.administration.apiKey}
                                onChange={this.onChangeValue.bind(this, 'apiKey')}
                                onBlur={this.onSaveValue.bind(this, 'apiKey')}
                            />
                        </>
                    }

                    {reseller.settings.administration.api === 'JORTT V2' &&
                        <>
                            <Input
                                label={t('clientId')}
                                value={reseller.settings.administration.clientId}
                                onChange={this.onChangeValue.bind(this, 'clientId')}
                                onBlur={this.onSaveValue.bind(this, 'clientId')}
                            />

                            <Input
                                label={t('clientSecret')}
                                value={reseller.settings.administration.clientSecret}
                                onChange={this.onChangeValue.bind(this, 'clientSecret')}
                                onBlur={this.onSaveValue.bind(this, 'clientSecret')}
                            />
                        </>
                    }

                    {reseller.settings.administration.api === 'WeFact' &&
                        <>
                            {reseller.settings.administration.api && ['yes', 'toVeloyd'].includes(reseller.settings.administration.syncCustomers) &&
                                <Input
                                    label={t('syncCustomersFromDebtorGroup')}
                                    info={t('syncCustomersFromDebtorGroupInfo')}
                                    value={reseller.settings.administration.customerGroup}
                                    onChange={this.onChangeValue.bind(this, 'customerGroup')}
                                    onBlur={this.onSaveValue.bind(this, 'customerGroup')}
                                />
                            }

                            <Input
                                label={t('apiKey')}
                                value={reseller.settings.administration.apiKey}
                                onChange={this.onChangeValue.bind(this, 'apiKey')}
                                onBlur={this.onSaveValue.bind(this, 'apiKey')}
                            />

                            <Toggle
                                label={t('checkConceptInvoices')}
                                info={t('checkConceptInvoicesInfo')}
                                checked={reseller.settings.administration.checkConceptInvoices}
                                onChange={this.onChangeChecked.bind(this, 'checkConceptInvoices')}
                            />

                            <Toggle
                                label={t('sendAttachmentTo', 'WeFact')}
                                checked={reseller.settings.administration.sendAttachment}
                                onChange={this.onChangeChecked.bind(this, 'sendAttachment')}
                            />

                            <Toggle
                                label={t('mergeOrdersOnOneInvoiceLine')}
                                checked={reseller.settings.administration.mergeOrders}
                                onChange={this.onChangeChecked.bind(this, 'mergeOrders')}
                            />

                            <Select
                                label={t('mergeParcels')}
                                value={reseller.settings.administration.mergeParcels}
                                info={t('mergeParcelsInfo')}
                                options={[
                                    {value: '', title: t('mergeParcelsOnOneInvoiceLine'), info: ''},
                                    {value: 'carrier', title: t('mergeParcelsPerCarrier'), info: t('mergeParcelsPerCarrierInfo')},
                                    {value: 'productCode', title: t('mergeParcelsPerProductCode'), info: t('mergeParcelsPerProductCodeInfo')}
                                ]}
                                onChange={this.onSaveValue.bind(this, 'mergeParcels')}
                            />

                            <Toggle
                                label={t('periodOnInvoiceLine')}
                                info={t('periodOnInvoiceLineInfo')}
                                checked={reseller.settings.administration.setPeriod}
                                onChange={this.onChangeChecked.bind(this, 'setPeriod')}
                            />

                            <Toggle
                                label={t('periodAsReference')}
                                checked={reseller.settings.administration.periodAsReference}
                                info={t('periodAsReferenceInfo')}
                                onChange={this.onChangeChecked.bind(this, 'periodAsReference')}
                            />

                            <Input
                                label={t('ordersProductCode')}
                                value={reseller.settings.administration.ordersProductCode}
                                onChange={this.onChangeValue.bind(this, 'ordersProductCode')}
                                onBlur={this.onSaveValue.bind(this, 'ordersProductCode')}
                            />

                            <Input
                                label={t('parcelsProductCode')}
                                value={reseller.settings.administration.parcelsProductCode}
                                onChange={this.onChangeValue.bind(this, 'parcelsProductCode')}
                                onBlur={this.onSaveValue.bind(this, 'parcelsProductCode')}
                            />

                            <Input
                                label={t('subscriptionsProductCode')}
                                value={reseller.settings.administration.subscriptionsProductCode}
                                onChange={this.onChangeValue.bind(this, 'subscriptionsProductCode')}
                                onBlur={this.onSaveValue.bind(this, 'subscriptionsProductCode')}
                            />
                        </>
                    }

                    {reseller.settings.administration.api === 'SnelStart' &&
                        <>
                            <P style={{marginBottom: 12}}>{t('snelstartDescription')}</P>

                            <Input
                                label={t('snelstartSubscriptionKey')}
                                info={t('snelstartSubscriptionKeyInfo')}
                                value={reseller.settings.administration.snelstartSubscriptionKey}
                                onChange={this.onChangeValue.bind(this, 'snelstartSubscriptionKey')}
                                onBlur={this.onSaveValue.bind(this, 'snelstartSubscriptionKey')}
                            />

                            <Input
                                label={t('snelstartClientKey')}
                                info={t('snelstartClientKeyInfo')}
                                value={reseller.settings.administration.snelstartClientKey}
                                onChange={this.onChangeValue.bind(this, 'snelstartClientKey')}
                                onBlur={this.onSaveValue.bind(this, 'snelstartClientKey')}
                            />

                            <Input
                                label={t('snelstartOrdersArticle')}
                                info={t('snelstartArticleInfo')}
                                value={reseller.settings.administration.ordersProductCode}
                                onChange={this.onChangeValue.bind(this, 'ordersProductCode')}
                                onBlur={this.onSaveValue.bind(this, 'ordersProductCode')}
                            />

                            <Input
                                label={t('snelstartParcelsArticle')}
                                info={t('snelstartArticleInfo')}
                                value={reseller.settings.administration.parcelsProductCode}
                                onChange={this.onChangeValue.bind(this, 'parcelsProductCode')}
                                onBlur={this.onSaveValue.bind(this, 'parcelsProductCode')}
                            />

                            {reseller.permissions?.shifts &&
                                <Input
                                    label={t('snelstartShiftsArticle')}
                                    info={t('snelstartArticleInfo')}
                                    value={reseller.settings.administration.shiftsProductCode}
                                    onChange={this.onChangeValue.bind(this, 'shiftsProductCode')}
                                    onBlur={this.onSaveValue.bind(this, 'shiftsProductCode')}
                                />
                            }

                            <Input
                                label={t('snelstartSubscriptionsArticle')}
                                info={t('snelstartArticleInfo')}
                                value={reseller.settings.administration.subscriptionsProductCode}
                                onChange={this.onChangeValue.bind(this, 'subscriptionsProductCode')}
                                onBlur={this.onSaveValue.bind(this, 'subscriptionsProductCode')}
                            />

                            <Toggle
                                label={t('periodAsReference')}
                                checked={reseller.settings.administration.periodAsReference}
                                info={t('periodAsReferenceInfo')}
                                onChange={this.onChangeChecked.bind(this, 'periodAsReference')}
                            />
                        </>
                    }

                    {reseller.settings.administration.api === 'Twinfield' &&
                        <>
                            <Input
                                label={t('name')}
                                value={reseller.settings.administration.apiName}
                                onChange={this.onChangeValue.bind(this, 'apiName')}
                                onBlur={this.onSaveValue.bind(this, 'apiName')}
                            />

                            <Input
                                label={t('password')}
                                type='password'
                                autoComplete='new-password'
                                value={reseller.settings.administration.apiPassword}
                                onChange={this.onChangeValue.bind(this, 'apiPassword')}
                                onBlur={this.onSaveValue.bind(this, 'apiPassword')}
                            />

                            <Input
                                label={t('organisation')}
                                value={reseller.settings.administration.apiOrganisation}
                                onChange={this.onChangeValue.bind(this, 'apiOrganisation')}
                                onBlur={this.onSaveValue.bind(this, 'apiOrganisation')}
                            />

                            <Input
                                label={t('administration')}
                                value={reseller.settings.administration.apiOffice}
                                onChange={this.onChangeValue.bind(this, 'apiOffice')}
                                onBlur={this.onSaveValue.bind(this, 'apiOffice')}
                            />

                            <Input
                                label={t('invoiceType')}
                                value={reseller.settings.administration.apiInvoiceType}
                                onChange={this.onChangeValue.bind(this, 'apiInvoiceType')}
                                onBlur={this.onSaveValue.bind(this, 'apiInvoiceType')}
                            />

                            <Input
                                label={t('invoiceDimension')}
                                value={reseller.settings.administration.apiInvoiceDim}
                                onChange={this.onChangeValue.bind(this, 'apiInvoiceDim')}
                                onBlur={this.onSaveValue.bind(this, 'apiInvoiceDim')}
                            />

                            <Input
                                label={t('vatCode')}
                                value={reseller.settings.administration.apiInvoiceVATCode}
                                onChange={this.onChangeValue.bind(this, 'apiInvoiceVATCode')}
                                onBlur={this.onSaveValue.bind(this, 'apiInvoiceVATCode')}
                            />
                        </>
                    }
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>{t('invoiceSettings')}</H5>

                <FormStack>
                    <Toggle
                        label={t('approveOrders')}
                        checked={reseller.settings.administration.checkOrders}
                        onChange={this.onChangeChecked.bind(this, 'checkOrders')}
                    />

                    <Toggle
                        label={t('showNameOnInvoice')}
                        info={t('showNameOnInvoiceInfo')}
                        checked={reseller.settings.administration.showNameOnInvoice}
                        onChange={this.onChangeChecked.bind(this, 'showNameOnInvoice')}
                    />

                    <Toggle
                        label={t('showOrderOverviewOnInvoice')}
                        checked={reseller.settings.administration.showOrderOverviewOnInvoice}
                        onChange={this.onChangeChecked.bind(this, 'showOrderOverviewOnInvoice')}
                    />

                    {reseller.settings.administration.showOrderOverviewOnInvoice &&
                        <Toggle
                            label={t('groupOrderOverviewByDay')}
                            info={t('groupOrderOverviewByDayInfo')}
                            checked={reseller.settings.administration.groupOrderOverviewByDay}
                            onChange={this.onChangeChecked.bind(this, 'groupOrderOverviewByDay')}
                        />
                    }

                    <Toggle
                        label={t('showOrderSpecificationOnInvoice')}
                        checked={reseller.settings.administration.showOrderSpecificationOnInvoice}
                        onChange={this.onChangeChecked.bind(this, 'showOrderSpecificationOnInvoice')}
                    />

                    <Toggle
                        label={t('showParcelOverviewOnInvoice')}
                        checked={reseller.settings.administration.showParcelOverviewOnInvoice}
                        onChange={this.onChangeChecked.bind(this, 'showParcelOverviewOnInvoice')}
                    />

                    <Toggle
                        label={t('showParcelSpecificationOnInvoice')}
                        checked={reseller.settings.administration.showParcelSpecificationOnInvoice}
                        onChange={this.onChangeChecked.bind(this, 'showParcelSpecificationOnInvoice')}
                    />

                    <Toggle
                        label={t('showPriceExplanationOrders')}
                        checked={reseller.settings.administration.showPriceExplanationOrders}
                        onChange={this.onChangeChecked.bind(this, 'showPriceExplanationOrders')}
                    />

                    {reseller.settings.administration.showPriceExplanationOrders && (
                        <Toggle
                            label={t('showColliBarcodeSpecification')}
                            info={t('showColliBarcodeSpecificationInfo')}
                            checked={reseller.settings.administration.showColliBarcodeSpecification}
                            onChange={this.onChangeChecked.bind(this, 'showColliBarcodeSpecification')}
                        />

                    )}

                    <Toggle
                        label={t('showPriceExplanationParcels')}
                        checked={reseller.settings.administration.showPriceExplanationParcels}
                        onChange={this.onChangeChecked.bind(this, 'showPriceExplanationParcels')}
                    />

                    <Toggle
                        label={t('invoiceOrdersPriceZero')}
                        checked={reseller.settings.administration.invoicePriceZero}
                        onChange={this.onChangeChecked.bind(this, 'invoicePriceZero')}
                    />

                    <Toggle
                        label={t('invoiceParcelsPriceZero')}
                        checked={reseller.settings.administration.invoiceParcelsPriceZero}
                        onChange={this.onChangeChecked.bind(this, 'invoiceParcelsPriceZero')}
                    />

                    <Toggle
                        label={t('invoiceSentOrdersOnly')}
                        info={t('invoiceSentOrdersOnlyInfo')}
                        checked={reseller.settings.administration.invoiceSendOrders}
                        onChange={this.onChangeChecked.bind(this, 'invoiceSendOrders')}
                    />

                    <Toggle
                        label={t('invoiceSentParcelsOnly')}
                        info={t('invoiceSentParcelsOnlyInfo')}
                        checked={reseller.settings.administration.invoiceSendParcels}
                        onChange={this.onChangeChecked.bind(this, 'invoiceSendParcels')}
                    />
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>{t('xmlExport')}</H5>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Toggle
                        label={t('enabled')}
                        checked={reseller.settings.administration.xmlExport}
                        onChange={this.onChangeChecked.bind(this, 'xmlExport')}
                    />

                    {reseller.settings.administration.xmlExport &&
                        <Editor
                            label={t('xmlExportTemplate')}
                            tags={['debtorCode', 'customerName', 'timeStamp', 'startDate', 'endDate', 'productCode', 'quantity']}
                            value={reseller.settings.administration.xmlExportTemplate}
                            onChange={this.onSaveValue.bind(this, 'xmlExportTemplate')}
                        />

                    }
                </FormStack>

                {reseller.name === 'Veloyd API Test' &&
                    <SnelStartVerification />
                }
            </Card>
        )
    }
}
